import { PayloadAction } from '@reduxjs/toolkit';

import { FontState, FontStatus, UploadedFontData } from 'editor/src/store/fonts/types';

const addUploadedFontsReducer = (state: FontState, action: PayloadAction<UploadedFontData[]>) => {
  const incomingReal = new Set(action.payload.filter((f) => !!f.fileUrl).map((f) => f.fontFile));
  // Evict failed placeholders (no fileUrl) so real fonts can replace them
  state.uploadedFonts = state.uploadedFonts.filter(
    (f) => !(f.loadingStatus === FontStatus.failed && !f.fileUrl && incomingReal.has(f.fontFile)),
  );
  const existingFontFiles = new Set(state.uploadedFonts.map((f) => f.fontFile));
  // Dedupe only by fontFile (the unique custom-<id>), NOT by filename. Each
  // InDesign import uploads fresh font records that reuse common filenames
  // (e.g. "OpenSans-Regular.ttf") but get distinct ids — and the imported
  // design references those specific ids. Deduping by filename would drop the
  // just-uploaded font whose id the design needs, leaving it unresolvable
  // ("unknown font") and collapsing the text.
  const newFonts = action.payload.filter((f) => !existingFontFiles.has(f.fontFile));
  state.uploadedFonts = [...newFonts, ...state.uploadedFonts];
};

export default addUploadedFontsReducer;
